<div class="smartphone">
  <div class="content">
    <div [innerHTML]="html"></div> 
  </div>
</div>
